import React, { useEffect, useState } from "react";
import api from "../api";
import { Gift, Copy, CheckCircle2, Users } from "lucide-react";

export default function Parrainage() {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get("/referral/me").then((r) => setData(r.data));
  }, []);

  if (!data) return <div>Chargement…</div>;

  const copyLink = () => {
    navigator.clipboard.writeText(data.link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareWA = `https://wa.me/?text=${encodeURIComponent(
    "Je viens de découvrir AUPRÉA, un carnet pour anticiper l'essentiel et protéger ceux qu'on aime. Tu peux créer le tien à ton rythme ici : " + data.link
  )}`;
  const shareMail = `mailto:?subject=${encodeURIComponent(
    "Un cadeau pour organiser l'essentiel — et protéger ceux que j'aime"
  )}&body=${encodeURIComponent(
    "Bonjour,\n\n" +
    "J'utilise AUPRÉA pour organiser tout ce qui compte : mon patrimoine, mes volontés, et les informations essentielles pour protéger mes proches en cas de coup dur.\n\n" +
    "On n'y pense jamais assez tôt, mais préparer ces sujets à l'avance, c'est un vrai cadeau pour ceux qu'on aime : ça leur évite des démarches compliquées et du stress au moment où ils en ont le moins besoin.\n\n" +
    "Je te propose de créer ton propre carnet AUPRÉA, à ton rythme et en toute confidentialité :\n" +
    data.link + "\n\n" +
    "N'hésite pas si tu as des questions, je serai ravi(e) d'en discuter avec toi.\n\n" +
    "À bientôt !"
  )}`;

  return (
    <div className="space-y-8">
      <div>
        <div style={{ color: "var(--auprea-gold)", fontSize: 12, letterSpacing: "0.2em", textTransform: "uppercase", fontWeight: 600, marginBottom: 12 }}>
          — Parrainage AUPREA
        </div>
        <h1 style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }} data-testid="parrainage-title">Parrainez vos proches</h1>
        <p style={{ fontSize: 17, color: "rgba(35,38,46,0.7)", marginTop: 8, maxWidth: 640 }}>
          Parrainez 3 personnes qui prennent un forfait Essentiel ou Confort, et recevez <strong>1 mois Confort offert</strong> à chaque palier de 3.
        </p>
      </div>

      <div className="auprea-card" style={{ borderColor: "var(--auprea-gold)" }}>
        <div className="flex items-center gap-3 mb-4">
          <Gift size={32} color="#caa86a" />
          <div>
            <div style={{ fontSize: 13, color: "rgba(35,38,46,0.6)", textTransform: "uppercase", letterSpacing: "0.1em" }}>Votre code</div>
            <div style={{ fontFamily: "Spectral, serif", fontSize: 36, color: "var(--auprea-navy)", letterSpacing: "0.1em" }} data-testid="referral-code">{data.code}</div>
          </div>
        </div>
        <div className="space-y-3">
          <div>
            <div style={{ fontSize: 12, textTransform: "uppercase", letterSpacing: "0.1em", color: "rgba(35,38,46,0.6)", marginBottom: 6 }}>
              Votre lien de parrainage
            </div>
            <div className="flex gap-2">
              <input readOnly className="auprea-input" value={data.link} data-testid="referral-link" />
              <button onClick={copyLink} className="auprea-btn" style={{ padding: "10px 16px" }} data-testid="btn-copy-link">
                {copied ? <CheckCircle2 size={18} /> : <Copy size={18} />}
              </button>
            </div>
          </div>
          <div className="flex gap-3 flex-wrap pt-2">
            <a href={shareWA} target="_blank" rel="noreferrer" className="auprea-btn-outline" data-testid="share-wa">Partager via WhatsApp</a>
            <a href={shareMail} className="auprea-btn-outline" data-testid="share-mail">Partager par e-mail</a>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <div className="auprea-card" data-testid="stat-referrals">
          <Users color="#caa86a" />
          <div style={{ fontSize: 12, color: "rgba(35,38,46,0.6)", textTransform: "uppercase", letterSpacing: "0.1em", marginTop: 12 }}>Filleuls payants</div>
          <div style={{ fontFamily: "Spectral, serif", fontSize: 36, color: "var(--auprea-navy)" }}>{data.paid_referrals}</div>
        </div>
        <div className="auprea-card" data-testid="stat-rewards">
          <Gift color="#caa86a" />
          <div style={{ fontSize: 12, color: "rgba(35,38,46,0.6)", textTransform: "uppercase", letterSpacing: "0.1em", marginTop: 12 }}>Mois offerts reçus</div>
          <div style={{ fontFamily: "Spectral, serif", fontSize: 36, color: "var(--auprea-navy)" }}>{data.rewards_granted}</div>
        </div>
        <div className="auprea-card">
          <div style={{ fontSize: 12, color: "rgba(35,38,46,0.6)", textTransform: "uppercase", letterSpacing: "0.1em" }}>Prochaine récompense</div>
          <div style={{ fontFamily: "Spectral, serif", fontSize: 24, color: "var(--auprea-navy)", marginTop: 8 }}>
            Encore <strong>{data.next_reward_in || data.threshold}</strong> filleul{(data.next_reward_in || data.threshold) > 1 ? "s" : ""}
          </div>
          <div style={{ fontSize: 13, color: "rgba(35,38,46,0.6)", marginTop: 4 }}>pour 1 mois Confort offert</div>
        </div>
      </div>
    </div>
  );
}
